/**
 * Mega Menu - Panel Centre Theme
 * Desktop: hover/focus mega dropdowns
 * Mobile: slide-out drawer with accordions
 */
(function () {
  'use strict';

  /* ---- Constants ---- */
  var HOVER_DELAY = 120;       // ms before closing on mouseleave
  var BREAKPOINT = 990;

  /* ---- Desktop Mega Menu ---- */
  function initDesktopMega() {
    var items = document.querySelectorAll('.mega-nav__item[data-mega-dropdown]');
    var closeTimer = null;

    items.forEach(function (item) {
      // The tile can use either .mega-nav__tile (new) or .mega-nav__link (legacy)
      var link = item.querySelector('.mega-nav__tile') || item.querySelector('.mega-nav__link');
      var dropdown = item.querySelector('.mega-dropdown');
      if (!dropdown) return;

      // Hover open
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        closeAllDesktop();
        openDesktopItem(item);
      });

      // Hover close with delay
      item.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          closeDesktopItem(item);
        }, HOVER_DELAY);
      });

      if (!link) return;

      // Click/tap
      link.addEventListener('click', function (e) {
        if (window.innerWidth >= BREAKPOINT && dropdown) {
          if (item.classList.contains('is-active')) {
            return;
          }
          if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
            e.preventDefault();
            closeAllDesktop();
            openDesktopItem(item);
          }
        }
      });

      // Keyboard
      link.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (item.classList.contains('is-active')) {
            closeDesktopItem(item);
            link.focus();
          } else {
            closeAllDesktop();
            openDesktopItem(item);
            var first = dropdown.querySelector('a');
            if (first) first.focus();
          }
        }
        if (e.key === 'Escape') {
          closeDesktopItem(item);
          link.focus();
        }
      });

      dropdown.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeDesktopItem(item);
          link.focus();
        }
      });
    });

    // Close on click outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.mega-nav__item[data-mega-dropdown]')) {
        closeAllDesktop();
      }
    });
  }

  function openDesktopItem(item) {
    item.classList.add('is-active');
    item.classList.add('is-open');
    var link = item.querySelector('.mega-nav__tile') || item.querySelector('.mega-nav__link');
    if (link) link.setAttribute('aria-expanded', 'true');
  }

  function closeDesktopItem(item) {
    item.classList.remove('is-active');
    item.classList.remove('is-open');
    var link = item.querySelector('.mega-nav__tile') || item.querySelector('.mega-nav__link');
    if (link) link.setAttribute('aria-expanded', 'false');
  }

  function closeAllDesktop() {
    document.querySelectorAll('.mega-nav__item.is-active').forEach(function (item) {
      closeDesktopItem(item);
    });
  }

  /* ---- Mobile Mega Menu ---- */
  function initMobileMega() {
    var nav = document.getElementById('mobile-mega-nav');
    if (!nav) return;

    var toggleBtn = document.querySelector('[data-mobile-menu-toggle]');
    var closeBtn = nav.querySelector('.mobile-mega-nav__close');
    var overlay = nav.querySelector('.mobile-mega-nav__overlay');
    var triggers = nav.querySelectorAll('.mobile-mega-nav__toggle');

    function openMobile() {
      nav.classList.add('is-open');
      document.body.classList.add('mobile-nav-open');
      // Trap focus
      trapFocus(nav.querySelector('.mobile-mega-nav__drawer'));
      // Focus close button
      if (closeBtn) closeBtn.focus();
    }

    function closeMobile() {
      nav.classList.remove('is-open');
      document.body.classList.remove('mobile-nav-open');
      if (toggleBtn) toggleBtn.focus();
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        if (nav.classList.contains('is-open')) {
          closeMobile();
        } else {
          openMobile();
        }
      });
    }

    if (closeBtn) closeBtn.addEventListener('click', closeMobile);
    if (overlay) overlay.addEventListener('click', closeMobile);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        closeMobile();
      }
    });

    // Accordion toggles
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var parent = trigger.closest('.mobile-mega-nav__item');
        if (!parent) return;
        var isOpen = parent.classList.contains('is-open');

        // Close all other panels
        nav.querySelectorAll('.mobile-mega-nav__item.is-open').forEach(function (openItem) {
          if (openItem !== parent) {
            openItem.classList.remove('is-open');
            var openTrigger = openItem.querySelector('.mobile-mega-nav__toggle');
            if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle this panel
        if (isOpen) {
          parent.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          parent.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---- Trap focus helper (reuse global if available) ---- */
  function trapFocus(container) {
    if (!container) return;
    if (typeof window.trapFocus === 'function') {
      window.trapFocus(container);
      return;
    }
    var focusable = container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    container.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          last.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === last) {
          first.focus();
          e.preventDefault();
        }
      }
    });
  }

  /* ---- Init ----
     Wrap each in its own try/catch so a failure in one doesn't stop the other.
  */
  function init() {
    try { initDesktopMega(); } catch (e) { console.error('[mega-menu] desktop init failed:', e); }
    try { initMobileMega(); } catch (e) { console.error('[mega-menu] mobile init failed:', e); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
